// OpenLayersMapWithMarkers.js
import { Map, Overlay, View } from 'ol'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import 'ol/ol.css'
import { fromLonLat } from 'ol/proj'
import { OSM } from 'ol/source'
import VectorSource from 'ol/source/Vector'
import { Icon, Style } from 'ol/style'
import React, { useEffect } from 'react'
import HQPrevix from '../../../../assets/images/Surveillance/mapIconPrevix.svg'
import EmployeeMarker from '../../../../assets/images/Surveillance/mapIconEmployee.svg'
import UserMarker from '../../../../assets/images/Surveillance/mapIconUser.svg'

import './styles.css'
// import { ContextLatestRequests } from '../../../../context/context_latestRequests'

const MapOccurrences = ({
  answerLocation,
  baseLocationData,
  userLocationData,
  employeeLocationData,
  setOccurrenceUserDetails,
  openDetails,
}) => {
  // const { handleFilters, callFilteredOccurrences } = useContext(
  //   ContextLatestRequests,
  // )

  const handleState = (setValue) => {
    setValue((prev) => !prev)
  }

  const handleOccurrenceUserDetails = (id) => {
    const info = userLocationData.find((item) => item.id === id)
    setOccurrenceUserDetails(info)
    handleState(openDetails)
  }

  const handleMap = () => {
    try {
      // Coordenadas iniciais do mapa
      const center = fromLonLat([-46.6619690168243, -23.554455450331602])

      // Criar a camada do mapa
      const map = new Map({
        target: 'mapOccurrence',
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
        ],
        view: new View({
          center,
          zoom: 10,
        }),
      })

      if (answerLocation) {
        // Criar a camada de marcadores
        const answerLocationLayer = new VectorLayer({
          source: new VectorSource(),
        })

        const { latitude, longitude } = answerLocation

        const answerLocationMarker = [
          {
            coordinates: fromLonLat([longitude, latitude]),
            icon: EmployeeMarker,
            scale: 2.5,
          },
          // Adicionar mais marcadores conforme necessário
        ]

        for (let i = 0; i < answerLocationMarker.length; i++) {
          const marker = answerLocationMarker[i]
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0, 0],
                src: marker.icon,
                scale: marker.scale,
              }),
            }),
          )
          feature.set('markerType', 'headQuarteMarker')
          answerLocationLayer.getSource().addFeature(feature)
        }

        map.addLayer(answerLocationLayer)
        map.render()
      }

      if (baseLocationData) {
        const baseLocationLayer = new VectorLayer({
          source: new VectorSource(),
        })

        const baseLocationMarker = Array.from(baseLocationData, (item) => ({
          coordinates: fromLonLat([item.longitude, item.latitude]),
          icon: HQPrevix,
          scale: 1,
        }))

        for (let i = 0; i < baseLocationMarker.length; i++) {
          const marker = baseLocationMarker[i]
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0, 0],
                src: marker.icon,
                scale: marker.scale,
              }),
            }),
          )
          feature.set('markerType', 'headQuarteMarker')
          baseLocationLayer.getSource().addFeature(feature)
        }

        map.addLayer(baseLocationLayer)
      }

      if (userLocationData) {
        const userLocationLayer = new VectorLayer({
          source: new VectorSource(),
        })

        const userLocationMarkers = Array.from(userLocationData, (item) => ({
          coordinates: fromLonLat([item.longitude, item.latitude]),
          icon: UserMarker,
          scale: 2,
          tooltipText: fromLonLat([item.longitude, item.latitude]).join(', '),
        }))

        for (let i = 0; i < userLocationMarkers.length; i++) {
          const marker = userLocationMarkers[i]
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0, 0],
                src: marker.icon,
                scale: marker.scale,
              }),
            }),
          )
          feature.set('markerType', 'userMarker')
          // feature.set('infos', marker.infos)
          userLocationLayer.getSource().addFeature(feature)
        }

        map.addLayer(userLocationLayer)
      }

      if (employeeLocationData) {
        const employeeLocationLayer = new VectorLayer({
          source: new VectorSource(),
        })

        const employeeLocationMarkers = Array.from(
          employeeLocationData,
          (item) => ({
            coordinates: fromLonLat([item.longitude, item.latitude]),
            icon: EmployeeMarker,
            scale: 2,
            tooltipText: fromLonLat([item.longitude, item.latitude]).join(', '),
          }),
        )

        for (let i = 0; i < employeeLocationMarkers.length; i++) {
          const marker = employeeLocationMarkers[i]
          const feature = new Feature(new Point(marker.coordinates))
          feature.setStyle(
            new Style({
              image: new Icon({
                anchor: [0, 0],
                src: marker.icon,
                scale: marker.scale,
              }),
            }),
          )
          feature.set('markerType', 'employeeMarker')
          employeeLocationLayer.getSource().addFeature(feature)
        }

        map.addLayer(employeeLocationLayer)
      }

      const popup = new Overlay({
        element: document.createElement('div'),
        positioning: 'bottom-left',
        stopEvent: false,
      })

      map.addOverlay(popup)

      // Set cursor to pointer on feature hover
      map.getViewport().addEventListener('pointermove', (event) => {
        const pixel = map.getEventPixel(event)
        const hit = map.forEachFeatureAtPixel(pixel, () => true)
        map.getViewport().style.cursor = hit ? 'pointer' : ''
      })

      // Clear cursor on mouse out
      map.getViewport().addEventListener('pointerout', () => {
        map.getViewport().style.cursor = ''
      })

      // Register click event on the map
      // map.on('click', (event) => {
      //   const feature = map.forEachFeatureAtPixel(
      //     event.pixel,
      //     (feature) => feature,
      //   )
      //   if (feature) {
      //     // A feature is clicked
      //     const coordinates = feature.getGeometry().getCoordinates()
      //     const markerType = feature.values_.markerType
      //     console.log(markerType)

      //     if (markerType === 'userMarker') {
      //       const infos = feature.values_.infos
      //       const createdAtDate = new Date(infos.created_at)
      //       const date = createdAtDate.toLocaleDateString()
      //       const time = createdAtDate.toLocaleTimeString()
      //       popup.setPosition(coordinates)
      //       popup.getElement().innerHTML = `
      //           <div class='popupContainer'>
      //           <div class='popupDataContainer'>
      //             <div>Usuário: <span>${infos.name}</span></div>
      //             <div>ID ocorrência: <span>${infos.code}</span></div>
      //             <div>Horário solicitação: <span>${time}</span></div>
      //             <div>Data: <span>${date}</span></div>
      //           </div>
      //           <button id='${infos.id}' class='popupButton' type='button' >Ver detalhes</button>
      //         </div>`
      //     }
      //     const popupButton = document.querySelector('.popupButton')

      //     // Adicione um ouvinte de evento de clique
      //     popupButton.for.addEventListener('click', function (e) {
      //       handleOccurrenceUserDetails(e.target.id)
      //     })
      //   } else {
      //     // No feature is clicked
      //     popup.setPosition(undefined)
      //   }
      // })

      return map
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const map = handleMap()
    return () => {
      if (map) map.dispose()
    }
  }, [answerLocation, baseLocationData, userLocationData, employeeLocationData])

  return (
    <div id="mapOccurrence" style={{ width: '100%', height: '400px' }}></div>
  )
}

export default MapOccurrences
